export const isSameMonthAndYear = (firstDate , secondDate) => {
    return firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
 }